export default __webpack_public_path__ + "static/media/7.d8db4870.jpeg";